import React, { Component } from 'react';
import StyledSelect from 'components/Select';
import styled from 'styled-components';
import { prop } from 'styled-tools';
import {
  PROPERTY_ATMORE,
  PROPERTY_MONTGOMERY,
  PROPERTY_WETUMPKA,
  PROPERTY_BETHLEHEM,
  PROPERTY_CHICAGO
} from 'utils/constants';

const propertySpecialRequests = {
  [PROPERTY_ATMORE]: [
    { value: 'MOBILE', label: 'Mobile Key Access' },
    { value: 'CRIB', label: 'Crib' },
    { value: 'EARLY', label: 'Early Check-in' },
    { value: 'ADA', label: 'Physically Challenged Guests' },
    { value: 'LATE', label: 'Late Check-out' },
    { value: 'LA', label: 'Late Arrival' },
    { value: 'LATE2', label: '2 PM LATE C/OUT' },
    { value: 'LATE5', label: '5 PM LATE C/OUT' },
    { value: 'ROLL', label: 'Rollaway Bed' },
    { value: 'HSTOOL', label: 'HANDICAP SHOWER STOOL' },
    { value: 'SS', label: 'Sister Sky Amenities' },
    { value: 'LT', label: 'Lather Amenities' },
    { value: 'EC', label: 'Echos Amenities' },
    { value: 'PET', label: 'Guest will check in w/ a DOG (PET)' }
  ],
  [PROPERTY_CHICAGO]: [
    { value: 'ADA', label: 'PHYSICALLY CHALLENGED' },
    { value: 'CCVP', label: 'CREDIT CARD WAIVED/VIP' },
    { value: 'CRIB', label: 'Crib' },
    { value: 'EARLY', label: 'EARLY CHECK IN REQUEST' },
    { value: 'HSTOOL', label: 'HANDICAP SHOWER STOOL' },
    { value: 'LA', label: 'LATE ARRIVAL' },
    { value: 'LATE', label: 'LATE CHECKOUT' },
    { value: 'MOBILE', label: 'MOBILE KEY ACCESS' },
    { value: 'PET', label: 'GUEST HAS A PET' },
    { value: 'ROLL', label: 'ROLLAWAY BED' },
    { value: 'SERVANIMAL', label: 'SERVICE ANIMAL' }
  ],
  [PROPERTY_MONTGOMERY]: [
    { value: 'LA', label: 'Late Arrival' },
    { value: 'LATE2', label: '2PM Late Check Out' },
    { value: 'LATE5', label: '5PM Late Check Out' },
    { value: 'EARLY', label: 'Early Check In Requested' },
    { value: 'MICRO', label: 'Microwave Requested' },
    { value: 'ALLERGY', label: 'Feather Free Requested' },
    { value: 'ADA', label: 'Physically Challenged Guests' },
    { value: 'PET', label: 'Assistance Dog' },
    { value: 'ROLL', label: 'Rollaway Bed' },
    { value: 'CRIB', label: 'Crib' },
    { value: 'LATE', label: 'Late Check Out' },
    { value: 'COFFEE', label: 'Coffee' }
  ],
  [PROPERTY_WETUMPKA]: [
    { value: 'ADA', label: 'Physically Challenged Guests' },
    { value: 'CRB', label: 'Crib Requested' },
    { value: 'FEATH', label: 'Feather Free Room Requested' },
    { value: 'LCO', label: 'Late Check Out Requested' },
    { value: 'PET', label: 'Guest has human assistance dog' },
    { value: 'RBR', label: 'Rollaway Bed Requested' },
    { value: 'LATE2', label: '2PM Late Check-out' },
    { value: 'EAR', label: 'Guest Request Early Arrival' },
    { value: 'LATE5', label: 'Do Not Use' }
  ],
  [PROPERTY_BETHLEHEM]: [
    { value: 'LCO', label: 'Late Check Out Requested' },
    { value: 'VIP', label: 'VIP Guest' },
    { value: 'CHAIR', label: 'Chairman Access' },
    { value: 'FTH', label: 'Feather Allergy' },
    { value: 'SPE', label: 'Special Occasion' },
    { value: 'COP', label: 'Complimentary Upgrade' },
    { value: 'B2B', label: 'Back to Back Reservations' },
    { value: 'ANIMAL', label: 'Service Animal in Room' },
    { value: 'LAR', label: 'Late Arrival' },
    { value: 'RWL', label: 'Rollaway Requested' },
    { value: 'ADJ', label: 'Adjoining Rooms Request' },
    { value: 'AMD', label: 'Amenity in Room' },
    { value: 'ANN', label: 'Anniversary Celebration' },
    { value: 'BUT', label: 'Butler Services' },
    { value: 'CRB', label: 'Crib Requested' },
    { value: 'SCOOT', label: 'Scooter Request' },
    { value: 'LOC', label: 'Local Newspaper' },
    { value: 'MOB', label: 'Mobility Impairment' },
    { value: 'RPE', label: 'Extra Bathrobe' },
    { value: 'SCR', label: 'ADA Shower Chair Requested' },
    { value: 'SF', label: 'Same Floor' },
    { value: 'SFA', label: 'Makeup Sofa Bed' },
    { value: 'TDR', label: 'Turndown Service Requested' },
    { value: 'UPG', label: 'Upgrade Request' },
    { value: 'VIS', label: 'Vision Impairment' },
    { value: 'VIW', label: 'Requesting room with River View' },
    { value: 'WHL', label: 'Wheelchair' },
    { value: 'XBA', label: 'Extra Bath Amenities' },
    { value: 'XBL', label: 'Extra Blanket' },
    { value: 'XHG', label: 'Extra Hangers' },
    { value: 'XLG', label: 'Extra Luggage Rack' },
    { value: 'XPL', label: 'Extra Pillow' },
    { value: 'ION', label: 'Ionizer' },
    { value: 'XTW', label: 'Extra Towels' },
    { value: 'HUM', label: 'Humidifier' },
    { value: 'HPW', label: 'Hypo Allergenic Pillows' },
    { value: 'HMY', label: 'Honeymoon' },
    { value: 'HEP', label: 'Air Purifier' },
    { value: 'HEA', label: 'Hearing Impairment' },
    { value: 'FPW', label: 'Foam Pillows' },
    { value: 'FLW', label: 'Flowers in Room' },
    { value: 'EHK', label: 'Early Housekeeping Service' },
    { value: 'ECG', label: 'Early Check In Guaranteed' },
    { value: 'EAR', label: 'Early Check-In Requested' },
    { value: 'DVD', label: 'DVD Player' },
    { value: 'DPW', label: 'Down Pillows' },
    { value: 'CVW', label: 'Requesting Room with City View' },
    { value: 'BDY', label: 'Birthday Celebration' },
    { value: 'HYP', label: 'Hypo-Allergenic Setup' }
  ]
};

const SpecialRequestsSelect = styled(StyledSelect)`
  @media screen and (max-width: ${prop('theme.breakpoints.small')}) {
    &.select-multi {
      .Select-control .Select-multi-value-wrapper .Select-value {
        display: flex;
        flex-direction: row;
        overflow: hidden;
      }
    }
  }
`;

export class SpecialRequests extends Component {
  handleBlur = () => {
    const { input } = this.props;
    const { onBlur, value } = input;

    onBlur && onBlur(value);
  };

  render() {
    const { input, id, property } = this.props;
    const { onChange, value } = input;

    return (
      <SpecialRequestsSelect
        multi={true}
        value={value}
        className="select-multi"
        id={id}
        removeSelected={false}
        options={property ? propertySpecialRequests[property] : []}
        onBlur={this.handleBlur}
        onChange={onChange}
      />
    );
  }
}

export default SpecialRequests;
